import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import CardActionArea from "@material-ui/core/CardActionArea";
import * as Constants from "../../consts/Constants.js";
import DefaultImage from "./images/defaultImage.png";
import check from "./images/check.png";
import cruz from "./images/cruz.png";
import { formatDateDDMMYYYYHHMM } from "../../utils/DateUtils";

import Style from "../../styles/js/StyleNewHistory.js";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <gutterBottom variant="h6" style={{ fontWeight: "bold" }}>
        {children}
      </gutterBottom>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const getSubcategory = (subcategory) => {
  return "- Subcategoria: " + subcategory;
};

export default function NewExpanded({ open, setOpen, newsSelected }) {
  const handleClose = () => {
    setOpen(false);
  };

  const style = Style();

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        style={{ fontSize: 20 }}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {newsSelected.title}{" "}
        </DialogTitle>
        <DialogContent dividers>
          <CardActionArea
            component="a"
            href={Constants.FINAL_URL_BINS + newsSelected.binId}
          >
          { newsSelected.binId !== 0 && (
            <CardMedia
              component="img"
              image={ Constants.FINAL_URL_BINS + newsSelected.binId }
              title="Click para ver la imagen en una nueva ventana"
            ></CardMedia> )}
          </CardActionArea>
          <CardContent>
            <Typography className={style.textExpanded}>
              {newsSelected.body}
            </Typography>

            <Typography className={style.textExpanded}>
              Categoria: {newsSelected.category}{" "}
              {newsSelected.subCategory !== undefined
                ? getSubcategory(newsSelected.subCategory)
                : null}
            </Typography>

            {newsSelected.url !== undefined ? (
              <Typography className={style.textExpanded}>
                <a href={newsSelected.url} target="blank">
                  Link noticia
                </a>{" "}
              </Typography>
            ) : null}

            <Typography className={style.textExpanded}>
              Fecha: {formatDateDDMMYYYYHHMM(newsSelected.creationTime)}
            </Typography>

            <div className={style.rowAlignEnd}>
              <Typography>Alerta </Typography>
              {newsSelected.alert ? (
                <img src={check} className={style.alertImage} />
              ) : (
                <img src={cruz} className={style.alertImage} />
              )}
            </div>
          </CardContent>
        </DialogContent>
      </Dialog>
    </div>
  );
}
